// Protect against Back-Forward Cache (bfcache) issues after form submission
//
// PROBLEM:
// When users create an item via the dialog and get redirected, clicking
// back shows a stale cached version of the list without the new item.
//
// Flow:
// 1. User on list page → clicks Create → dialog opens (no URL change)
// 2. User submits form → redirected to success page
// 3. User clicks back → sees cached list (missing new item)
//
// SOLUTION:
// - Store update timestamp in localStorage after form submission (see formValidation.ts)
// - On pageshow, compare timestamp with page load time
// - Reload if data modified after page loaded
//
// This ensures users always see current data when navigating back.

export function setupBfCacheProtection() {
  const pageLoadTime = Date.now();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      const lastFormSubmitTimestamp = localStorage.getItem(
        'lastFormSubmitTimestamp',
      );
      if (lastFormSubmitTimestamp) {
        const lastSubmitTime = parseInt(lastFormSubmitTimestamp, 10);
        // If the form was submitted after the page was loaded, reload the page
        if (pageLoadTime < lastSubmitTime) {
          window.location.reload();
        }
      }
    }
  });
}
